import api from './api';

const auditLogService = {
  async list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.entityType) params.set('entityType', filters.entityType);
    if (filters.action) params.set('action', filters.action);
    if (filters.limit) params.set('limit', String(filters.limit));
    const qs = params.toString();
    const response = await api.get(`/partners/audit-log${qs ? `?${qs}` : ''}`);
    return response.data;
  }
};

export default auditLogService;
